<div class="flex flex-row justify-center">
	<lib-toaster *ngFor="let toast of (toasts$ | async); let i=index" [toast]="toast" [i]="i" (remove)="remove(toast)"></lib-toaster>
</div>